export enum TableActions {
  "delete" = "delete",
  "edit" = "edit",
}
export type TableActionType = (typeof TableActions)[keyof typeof TableActions];

export interface KeyValue {
  [key: string]: any;
}

export interface LabelValue {
  value: string;
  label: string;
}

export type RefDropdownHandle = {
  resetValues: (values?: string[]) => void;
};

export type TableRefHandle = {
  resetPagination: (shouldResetRowsPerPage?: boolean) => void;
};

export interface DefaultValueExceptionType {
  country?: string;
  units: string;
  measurement: string;
  countryCode: string;
  measurementName?: string | number;
  [key: string]: any;
}

export interface UserRole {
  roleId: string;
  role: string;
  groupName: string;
}

export interface UserBasicDetails {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
}

export interface UserDetails {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  rightOffice?: string;
  officeName?: string;
}
export interface Category {
  categoryId: string;
  categoryName: string;
}

export enum BulkProcessCategoryEnum {
  EDIT = "EDIT",
  CREATE = "CREATE",
  INSERT_ACTIVITIES = "INSERT_ACTIVITIES",
  TRANSFER_PARTICIPANTS = "TRANSFER_PARTICIPANTS",
}

export const BulkProcessCategoryLabel = {
  [BulkProcessCategoryEnum.EDIT]: "Bulk Edit Process",
  [BulkProcessCategoryEnum.CREATE]: "Bulk Create Process",
  [BulkProcessCategoryEnum.INSERT_ACTIVITIES]: "Bulk Insert Activities",
  [BulkProcessCategoryEnum.TRANSFER_PARTICIPANTS]: "Bulk Transfer Participants",
} as const;

export interface MenuItemConfig<RowProps> {
  permissionKey?: string;
  show?: (row: RowProps) => boolean;
  create: (row: RowProps) => any;
}

export interface Function {
  id: string;
  name: string;
  identifier: string;
}

export type GroupedOption = {
  id: string;
  name: string;
  groupBy: string;
};

export interface RecordStats {
  total: { count: number; label: string };
  processed: { count: number; label: string };
  unprocessed?: { count: number; label: string };
}
